var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhoneWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49408 1.99408C1.3378 2.15036 1.25 2.36232 1.25 2.58333V3C1.25 6.45167 4.04833 9.25 7.5 9.25H7.91667C8.13768 9.25 8.34964 9.1622 8.50592 9.00592C8.6622 8.84964 8.75 8.63768 8.75 8.41667V7.05042C8.75002 6.96293 8.7225 6.87766 8.67135 6.80669C8.6202 6.73572 8.548 6.68265 8.465 6.655L6.59292 6.03083C6.49778 5.99921 6.39442 6.00295 6.30181 6.04137C6.20921 6.07979 6.13356 6.15031 6.08875 6.24L5.61792 7.18042C4.59769 6.71945 3.78055 5.90231 3.31958 4.88208L4.26 4.41125C4.34969 4.36644 4.42021 4.29079 4.45863 4.19819C4.49705 4.10558 4.50079 4.00222 4.46917 3.90708L3.845 2.035C3.81738 1.95207 3.76437 1.87992 3.69348 1.82877C3.62259 1.77762 3.53741 1.75007 3.45 1.75H2.08333C1.86232 1.75 1.65036 1.8378 1.49408 1.99408Z",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneWhite);
export default __webpack_public_path__ + "static/media/ic_phone_white.9bf5ab9224e33dfa7da1959bb3781f5a.svg";
export { ForwardRef as ReactComponent };